import { ValidatePromotionCodeResponse } from "@func-core/core/data/adapters";
import { DiscountCampaigns } from "@settings/discounts";

export const PromotionCodeType = {
  AMOUNT: "amount",
  PERCENTAGE: "percentage",
} as const;

export interface Coupon {
  id: string;
  amount_off: number;
  percent_off: number;
  type: typeof PromotionCodeType[keyof typeof PromotionCodeType];
}

export interface PromotionCodeDTO {
  code: string;
  coupon: Coupon;
  id: string;
}

export interface PromotionCodeViewModel extends PromotionCodeDTO {
  isAmountCoupon: boolean;
  isBecasCampaign: boolean;
  isBecasCompressedCampaign: boolean;
}

export const createPromotionCodeViewModel = (
  data: ValidatePromotionCodeResponse
): PromotionCodeViewModel | null => {
  if (!data) return null;

  const isAmountCoupon = data.coupon.type === PromotionCodeType.AMOUNT;
  const isBecasCompressedCampaign = Object.entries(DiscountCampaigns).some(
    ([key, value]) => key.endsWith("_compressed") && value === data.code
  );
  const isBecasCampaign =
    Object.values(DiscountCampaigns).includes(data.code) && !isBecasCompressedCampaign;

  return {
    ...data,
    isAmountCoupon,
    isBecasCampaign,
    isBecasCompressedCampaign,
  };
};
